// extracted by mini-css-extract-plugin
export default {"button":"shipping_button__vbPCE","modalShipping":"shipping_modalShipping__CXf5M"};